export default class Forbidden extends Error {
  /**
   * 授權失敗
   */
  constructor(message) {
    super(message);
    this.name = 'Forbidden';
    this.StatusCode = 403;
  }
}
